// Copyright (c) Cratis. All rights reserved.
// Licensed under the MIT license. See LICENSE file in the project root for full license information.

/**
 * Well-known IoC binding constants.
 */
export const WellKnownBindings = {
    queryParams: 'queryParams',
    params: 'params',
    props: 'props'
};
